// Robust video autoplay with fallback, ported from the original coming-soon page.
document.querySelectorAll('.ij-hero').forEach((hero) => {
  const video = hero.querySelector('.ij-hero__video');
  const playHint = hero.querySelector('.ij-hero__play-hint');
  if (!video) return;

  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');

  let hasPlayed = false;

  const tryPlay = () => {
    if (hasPlayed) return Promise.resolve();
    const p = video.play();
    if (p && typeof p.then === 'function') {
      return p
        .then(() => {
          hasPlayed = true;
        })
        .catch(() => {});
    }
    hasPlayed = true;
    return Promise.resolve();
  };

  tryPlay();
  video.addEventListener('loadeddata', tryPlay);
  video.addEventListener('canplay', tryPlay);
  window.addEventListener('load', tryPlay);

  ['touchstart', 'click', 'keydown', 'scroll', 'mousemove'].forEach((evt) => {
    document.addEventListener(evt, tryPlay, { once: true, passive: true });
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) tryPlay();
  });

  setTimeout(() => {
    if (video.paused && !hasPlayed) {
      hero.classList.add('video-blocked');
    }
  }, 2000);

  if (playHint) {
    playHint.addEventListener('click', () => {
      video
        .play()
        .then(() => {
          hasPlayed = true;
          hero.classList.remove('video-blocked');
        })
        .catch(() => {});
    });
  }
});
